var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { DogRecipeInfo } from '@content/products/meals';
import Flyout from '@marketing/components/funnel/Flyout';
import Accordion from '@marketing/components/funnel/Flyout/Accordion';
import RadioCheckboxCard from '@marketing/components/funnel/FormFields/RadioCheckboxCard';
import ProductCard from '@marketing/components/funnel/ProductCard';
import { NewProduct, ProductImageNameAndPrice, TopPick, } from '@marketing/components/funnel/ProductCard/ProductCard';
import AAFCONutritionLabel from '@marketing/components/global/misc/AAFCONutritionLabel';
import { recipeInfo } from '@marketing/content';
import { useProfileContext } from '@marketing/profile/ProfileContext';
import { ProfileFormLayout, ProfileFormMain } from '@marketing/profile/common/ProfileFormLayout';
import SelectRecipesText from '@marketing/profile/common/SelectRecipesText';
import { trackStartBuildABowl } from '@marketing/profile/trackers';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router';
import { getMaxNumPets, getRecommendedRecipes, prioritizeProducts } from '../../utils';
import { useRequestSignal } from '@components/common/custom_hooks';
import axios from '@customAxios';
import { Kind } from '@customTypes/models';
import { getEstimatedWeeksFoodWillLastText, isOutOfStockRecipe, makeDeepCopy, } from '@utils/common_utils';
import { DAYS_OF_FOOD_PER_INTERVAL_MAP, DEFAULT_FIXED_SKU_GRAMS_BY_PET, DELIVERY_INTERVALS, DELIVERY_INTERVALS_DISPLAY_MAP, FREE_PRODUCT_DISPLAY_NAMES, MAX_NUM_RECIPES_FOR_FLEXIBLE_FOOD_SIGNUP, NUM_MEAL_PACKS_PER_BUNDLE, POUNDS_PER_FOOD_BUNDLE_BY_PET, RECIPE_MODE, } from '@variables';
var RecipeDetails = function (_a) {
    var isFlyoutOpen = _a.isFlyoutOpen, isTopPick = _a.isTopPick, recipe = _a.recipe, toggleOpen = _a.toggleOpen;
    var description = recipe.description, descriptionLong = recipe.descriptionLong, displayName = recipe.displayName, ingredients = recipe.ingredients, isNew = recipe.isNew;
    var serverLoading = useProfileContext().serverLoading;
    return (_jsx(Flyout, __assign({ isOpen: isFlyoutOpen, onToggle: function () { return toggleOpen(recipe.name); } }, { children: _jsx("div", __assign({ className: "p-5 md:p-12" }, { children: _jsxs("div", __assign({ className: "grid grid-cols-1 gap-12 md:gap-16 mt-12" }, { children: [_jsxs("div", __assign({ className: "grid grid-cols-1 gap-4" }, { children: [_jsx(ProductImageNameAndPrice, { disabled: serverLoading, imageData: {
                                    src: recipeInfo[recipe.name].funnelImage.src,
                                    alt: recipeInfo[recipe.name].funnelImage.alt,
                                }, isFlyout: true, productId: recipe.name, productName: displayName, price: DogRecipeInfo[recipe.name].v9SingleBundleSubtotal, type: "meal" }), _jsx("div", __assign({ className: "text-sm-reg-m md:text-sm-reg-d capitalize" }, { children: description })), isTopPick ? _jsx(TopPick, { onCard: false }) : isNew ? _jsx(NewProduct, { onCard: false }) : null] })), _jsxs("div", { children: [_jsx(Accordion, __assign({ className: "py-4", title: "Details" }, { children: _jsx("p", { children: descriptionLong }) })), _jsx(Accordion, __assign({ className: "py-4", title: "Nutrition" }, { children: _jsx(AAFCONutritionLabel, { recipe: recipe.name, type: "recipe" }) })), _jsx(Accordion, __assign({ className: "py-4", title: "Ingredients" }, { children: typeof ingredients === 'string' && _jsx("p", { children: ingredients }) }))] })] })) })) })));
};
var PORTIONS_OPTIONS = [
    {
        id: 'half',
        label: 'Half Portions',
        description: 'Add 50% of our food to 50% of their current food.',
        value: 0.5,
    },
    {
        id: 'topper',
        label: 'Topper Portions',
        description: 'Add a bit of our food to their current food for a flavor boost.',
        value: 0.25,
    },
];
/* Get copy of currently selected recipes for a pet. */
var getSelectedRecipes = function (pet) {
    if (pet.recipeMix.length) {
        return __spreadArray([], pet.recipeMix, true);
    }
    else if (pet.recipeRotation.length) {
        return __spreadArray([], pet.recipeRotation, true);
    }
    else if (pet.recipe) {
        return [pet.recipe];
    }
    return [];
};
var calculateMealPlanItems = function (pet, selectedRecipes) {
    if (!selectedRecipes || !pet.petType) {
        return [];
    }
    return selectedRecipes.map(function (recipe) {
        return {
            recipe: { kind: Kind.Recipe, name: recipe },
            gramsBucket: DEFAULT_FIXED_SKU_GRAMS_BY_PET[pet.petType],
            mealBags: NUM_MEAL_PACKS_PER_BUNDLE,
        };
    });
};
var PetMealsForm = function () {
    var navigate = useNavigate();
    var _a = useProfileContext(), profileData = _a.profileData, currentPetIndex = _a.currentPetIndex, currentPet = _a.currentPet, currentPetSurvey = _a.currentPetSurvey, saveProfile = _a.saveProfile, serverLoading = _a.serverLoading, updateCurrentPet = _a.updateCurrentPet, profileBasePath = _a.profileBasePath, freeGiftWithPurchase = _a.freeGiftWithPurchase, setFacebookSubscribeEventProps = _a.setFacebookSubscribeEventProps;
    var petRecipes = profileData.recipes
        .filter(function (recipe) { return recipe.petType === currentPet.petType && !recipe.deleted; })
        .map(function (recipe) {
        return __assign(__assign({}, recipe), DogRecipeInfo[recipe.name]);
    });
    var _b = useState(function () {
        if (currentPet.recipe) {
            return currentPet.recipeMode === RECIPE_MODE.MIX ? currentPet.recipeMix : [currentPet.recipe];
        }
        return [];
    }), recipes = _b[0], setRecipes = _b[1];
    var _c = useState(false), isFlyoutOpen = _c[0], setIsFlyoutExpanded = _c[1];
    var _d = useState(petRecipes[0]), clickedRecipe = _d[0], setClickedRecipe = _d[1];
    var _e = useState(profileData.deliveryInterval), deliveryInterval = _e[0], setDeliveryInterval = _e[1];
    var _f = useState(0), estimatedDaysFoodWillLast = _f[0], setEstimatedDaysFoodWillLast = _f[1];
    var requestSignal = useRequestSignal();
    // Set default quantityMultiplier to 0.5 if currentPet.quantityMultiplier is 1
    // This is mostly because of switching from Personalized to Flexible flow.
    var _g = useState(currentPet.quantityMultiplier === 1 ? 0.5 : currentPet.quantityMultiplier), quantityMultiplier = _g[0], setQuantityMultiplier = _g[1];
    var recommendedRecipes = useMemo(function () {
        var recommendedRecipes = getRecommendedRecipes(currentPetSurvey.purchasingMotivations, MAX_NUM_RECIPES_FOR_FLEXIBLE_FOOD_SIGNUP, currentPet.currentWeight > currentPet.weight);
        if (!currentPet.recipe) {
            setRecipes(recommendedRecipes);
        }
        return recommendedRecipes;
    }, [currentPetSurvey.purchasingMotivations]);
    useEffect(function () {
        trackStartBuildABowl(profileData, setFacebookSubscribeEventProps);
    }, []);
    useEffect(function () {
        getSubscriptionPlan();
    }, [recipes, quantityMultiplier]);
    var toggleFlyout = function (recipeName) {
        setClickedRecipe(function () {
            return __assign(__assign({}, petRecipes.find(function (recipe) { return recipe.name === recipeName; })), DogRecipeInfo[recipeName]);
        });
        setIsFlyoutExpanded(function (prev) { return !prev; });
    };
    var handleSelectRecipe = function (recipeName) {
        var selectedRecipes = recipes.includes(recipeName)
            ? recipes.filter(function (selectedRecipe) { return selectedRecipe !== recipeName; })
            : __spreadArray(__spreadArray([], recipes, true), [recipeName], false);
        setRecipes(selectedRecipes);
        updateCurrentPet({
            recipeMode: selectedRecipes.length > 1 ? RECIPE_MODE.MIX : RECIPE_MODE.FIXED,
            recipe: selectedRecipes[0],
            recipeMix: selectedRecipes.length > 1 ? selectedRecipes : [],
        });
    };
    var handleClickPrevious = function () {
        navigate("".concat(profileBasePath, "/pet/").concat(currentPetIndex, "/purchasing_motivations"), {
            viewTransition: true,
        });
    };
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var petProfileData, petsCopy, nextPath, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    petProfileData = {
                        recipeMode: recipes.length > 1 ? RECIPE_MODE.MIX : RECIPE_MODE.FIXED,
                        recipe: recipes[0],
                        recipeMix: recipes.length > 1 ? recipes : [],
                        quantityMultiplier: quantityMultiplier,
                        mealPlanItems: recipes.map(function (recipe) {
                            return {
                                recipe: recipe,
                                gramsBucket: DEFAULT_FIXED_SKU_GRAMS_BY_PET[currentPet.petType],
                                mealBags: NUM_MEAL_PACKS_PER_BUNDLE,
                            };
                        }),
                    };
                    updateCurrentPet(petProfileData);
                    petsCopy = profileData.pets.map(function (pet, index) {
                        return index === Number(currentPetIndex)
                            ? __assign(__assign({}, pet), petProfileData) : pet;
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, saveProfile({ pets: petsCopy })];
                case 2:
                    _a.sent();
                    nextPath = profileData.pets.length === getMaxNumPets(profileData.version)
                        ? 'addons'
                        : 'add_another_dog';
                    navigate("".concat(profileBasePath, "/").concat(nextPath), { viewTransition: true });
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error('Error saving profile:', error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // Determines delivery interval based on estimatedWeeksFoodWillLast, will round down
    // to ensure customer doesn't run out of food
    var determineDeliveryInterval = function (estimatedWeeksFoodWillLast) {
        if (estimatedWeeksFoodWillLast >= 8) {
            return DELIVERY_INTERVALS.EIGHT_WEEKS;
        }
        if (estimatedWeeksFoodWillLast >= 6) {
            return DELIVERY_INTERVALS.SIX_WEEKS;
        }
        if (estimatedWeeksFoodWillLast >= 4) {
            return DELIVERY_INTERVALS.MONTHLY;
        }
        if (estimatedWeeksFoodWillLast >= 3) {
            return DELIVERY_INTERVALS.THREE_WEEKS;
        }
        if (estimatedWeeksFoodWillLast >= 2) {
            return DELIVERY_INTERVALS.BIWEEKLY;
        }
        return DELIVERY_INTERVALS.WEEKLY;
    };
    var getSubscriptionPlan = function () { return __awaiter(void 0, void 0, void 0, function () {
        var petsPayload, newRequestSignal, response, subscriptionPlan, petMealPlanNutrition, minDaysFoodWillLast_1, estimatedWeeksFoodWillLast, newDeliveryInterval, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    petsPayload = profileData.pets.reduce(function (payload, row, index) {
                        var petPayload = makeDeepCopy(row);
                        var isCurrentPet = index === Number(currentPetIndex);
                        // If current pet, use selectedRecipes on the page, if another pet, use any
                        // previously selected recipes. Otherwise, use recommended recipes in request to
                        // GetSubscriptionPlan
                        var selectedRecipes = isCurrentPet ? recipes : getSelectedRecipes(petPayload);
                        if (!recipes.length) {
                            selectedRecipes = getRecommendedRecipes(profileData.petSurveys[index].purchasingMotivations, MAX_NUM_RECIPES_FOR_FLEXIBLE_FOOD_SIGNUP);
                        }
                        // Overwrite the recipeMode to FIXED if only 1 recommended recipe
                        petPayload.recipeMode = selectedRecipes.length > 1 ? RECIPE_MODE.MIX : RECIPE_MODE.FIXED;
                        petPayload.recipeMix = selectedRecipes.length > 1 ? selectedRecipes : [];
                        petPayload.recipeRotation = [];
                        // If current pet, use quantityMultiplier on the page, if another pet, use the default
                        // half portions
                        petPayload.quantityMultiplier = isCurrentPet
                            ? quantityMultiplier
                            : petPayload.quantityMultiplier;
                        payload.push(__assign(__assign({}, petPayload), { recipe: { kind: Kind.Recipe, name: selectedRecipes[0] }, mealPlanItems: calculateMealPlanItems(petPayload, selectedRecipes) }));
                        return payload;
                    }, []);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    newRequestSignal = requestSignal();
                    return [4 /*yield*/, axios.post('/api/pricing/get_subscription_plan', {
                            costModelId: profileData.costModel || 'v9',
                            daysOfFood: DAYS_OF_FOOD_PER_INTERVAL_MAP[deliveryInterval] || profileData.daysOfFood,
                            pets: petsPayload,
                        }, { signal: newRequestSignal })];
                case 2:
                    response = _a.sent();
                    subscriptionPlan = response.data;
                    petMealPlanNutrition = subscriptionPlan &&
                        subscriptionPlan.mealPlanNutrition &&
                        subscriptionPlan.mealPlanNutrition[currentPetIndex];
                    if (petMealPlanNutrition) {
                        setEstimatedDaysFoodWillLast(petMealPlanNutrition.estimatedDaysFoodWillLast);
                        minDaysFoodWillLast_1 = subscriptionPlan.mealPlanNutrition[0].estimatedDaysFoodWillLast;
                        subscriptionPlan.mealPlanNutrition.forEach(function (mealPlanNutrition) {
                            var estimatedDaysFoodWillLast = mealPlanNutrition.estimatedDaysFoodWillLast;
                            if (estimatedDaysFoodWillLast < minDaysFoodWillLast_1) {
                                minDaysFoodWillLast_1 = estimatedDaysFoodWillLast;
                            }
                        });
                        estimatedWeeksFoodWillLast = minDaysFoodWillLast_1 && Math.floor(minDaysFoodWillLast_1 / 7);
                        newDeliveryInterval = estimatedWeeksFoodWillLast >= 0 && determineDeliveryInterval(estimatedWeeksFoodWillLast);
                        if (newDeliveryInterval && newDeliveryInterval !== deliveryInterval) {
                            setDeliveryInterval(newDeliveryInterval);
                        }
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    if (!axios.isCancel(error_2)) {
                        console.error('Failed to get subscription plan', error_2);
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var prioritizedRecipes = prioritizeProducts(petRecipes, recommendedRecipes);
    var formId = 'pet-meals-form';
    return (_jsxs(ProfileFormLayout, __assign({ disableNext: recipes.length === 0, formId: formId, handleClickPrevious: handleClickPrevious }, { children: [_jsx(ProfileFormMain, __assign({ h1: "Nom Nom Sign Up: Recipes For Your Dog" }, { children: _jsxs("div", __assign({ className: "grid grid-cols-1 gap-6 md:gap-10" }, { children: [_jsxs("div", __assign({ className: "text-center" }, { children: [_jsxs("h2", __assign({ className: "font-medium" }, { children: [currentPet.name, "\u2019s Recipe Recommendations"] })), _jsxs("div", __assign({ className: "grid grid-cols-1 gap-4" }, { children: [_jsx(SelectRecipesText, { recommendedRecipes: recommendedRecipes }), _jsxs("p", { children: ["Select as many recipes as you think ", currentPet.name, " would like below, and we\u2019ll send 6 lbs of each recipe chosen. Free shipping on orders with 2+ recipes.", freeGiftWithPurchase && (_jsxs(_Fragment, { children: [' ', "FREE ", FREE_PRODUCT_DISPLAY_NAMES[freeGiftWithPurchase.productType], " will be automatically added to your order!"] }))] })] }))] })), _jsxs("form", __assign({ id: formId, onSubmit: handleSubmit, className: "grid grid-cols-1 gap-6 md:gap-20" }, { children: [_jsx("div", __assign({ className: "grid grid-cols-1 md:grid-cols-2 gap-6 px-5 md:p-0" }, { children: prioritizedRecipes.map(function (recipe) {
                                        var _a = DogRecipeInfo[recipe.name], isNew = _a.isNew, v9SingleBundleSubtotal = _a.v9SingleBundleSubtotal;
                                        var disabled = serverLoading ||
                                            (recipes.length > 0 &&
                                                MAX_NUM_RECIPES_FOR_FLEXIBLE_FOOD_SIGNUP === recipes.length &&
                                                !recipes.includes(recipe.name));
                                        var isOutOfStock = isOutOfStockRecipe(recipe.name, currentPet.gramsBucket);
                                        return (_jsx(ProductCard, { disabled: disabled || isOutOfStock, handleSelectProduct: handleSelectRecipe, imageData: {
                                                src: recipeInfo[recipe.name].funnelImage.src,
                                                alt: recipeInfo[recipe.name].funnelImage.alt,
                                            }, ingredients: recipe.description, isNew: isNew, isOutOfStock: isOutOfStock, isTopPick: recommendedRecipes.includes(recipe.name), isSelected: recipes.includes(recipe.name), price: v9SingleBundleSubtotal, productId: recipe.name, productName: recipe.displayName, toggleFlyout: toggleFlyout, type: "meal" }, "dog-recipe-".concat(recipe.name)));
                                    }) })), recipes.length > 0 && (_jsxs("div", __assign({ className: "group grid grid-cols-1 gap-6 md:gap-10" }, { children: [_jsx("h2", __assign({ className: "text-center font-medium" }, { children: "How do you want to serve?" })), _jsx("div", __assign({ className: "w-full md:w-fit px-5 md:px-0 mx-auto grid grid-cols-1 md:grid-cols-2 justify-items-center gap-6 md:gap-3" }, { children: PORTIONS_OPTIONS.map(function (option) {
                                                var optionId = "".concat(option.id, "-portions");
                                                return (_jsx("div", __assign({ className: "w-full mx-auto" }, { children: _jsx(RadioCheckboxCard, __assign({ className: "p-4 md:p-6", checked: quantityMultiplier === option.value, name: "gender", onInputChange: function () {
                                                            setQuantityMultiplier(option.value);
                                                        }, optionId: optionId, type: "radio", value: option.value }, { children: _jsxs("div", __assign({ className: "grid grid-cols-1 gap-2 text-left" }, { children: [_jsx("p", __assign({ className: "capitalize text-xs-head-m md:text-xs-head-d font-display" }, { children: option.label })), _jsx("p", __assign({ className: "text-sm-reg-m md:text-sm-reg-d" }, { children: option.description }))] })) })) }), optionId));
                                            }) })), recipes.length > 0 && estimatedDaysFoodWillLast && (_jsxs("div", __assign({ className: "grid grid-cols-1 gap-4" }, { children: [_jsx("p", { children: "What you\u2019ll get:" }), _jsxs("ul", __assign({ className: "list-disc pl-7 grid grid-cols-1 gap-4" }, { children: [_jsxs("li", { children: [recipes.length * POUNDS_PER_FOOD_BUNDLE_BY_PET[currentPet.petType], " lbs of food (", getEstimatedWeeksFoodWillLastText(estimatedDaysFoodWillLast), " if feeding ", quantityMultiplier === 0.25 ? 'topper' : 'half', " portions)"] }), _jsxs("li", { children: ["Deliveries every ", DELIVERY_INTERVALS_DISPLAY_MAP[deliveryInterval], " (so you", profileData.pets.length > 1 ? ' and your other pups' : '', " never run out)"] }), _jsx("li", { children: "Make changes or cancel any time after your first order" })] }))] })))] })))] }))] })) })), _jsx(RecipeDetails, { isFlyoutOpen: isFlyoutOpen, isTopPick: recommendedRecipes.includes(clickedRecipe.name), recipe: clickedRecipe, toggleOpen: toggleFlyout })] })));
};
export default PetMealsForm;
